module.exports = __webpack_public_path__ + "static/media/1POLICY25.8863beab.jpg";